export default __webpack_public_path__ + "static/shin-de7f806ea3395f4765bc7dec5ed82118.jpg";